import { IAppointmentHistory, IClient } from "intake_shared/src/types";
import { Tabs } from "../../../bits/Tabs/Tabs";
import AppointmentHistory from "../AppointmentHistory/AppointmentHistory";
import styles from "./AppointmentHeld.module.scss";
import AppointmentHeldDetails from "./AppointmentHeldDetails/AppointmentHeldDetails";
import {
    TSaveClient,
    TUpdateClient,
    TUpdateClientByStatus,
} from "../../clientUiTypes";
import EmptyListState from "../../../bits/EmptyListState/EmptyListState";
import { uniqBy } from "lodash";
import IntakeSessionHistory from "../AppointmentHistory/IntakeSessionHistory";

interface AppointmentHeldProps {
    initialHistories?: IAppointmentHistory[];
    client: IClient;
    updateClient: TUpdateClient;
    updateClientByStatus: TUpdateClientByStatus;
    onSaveClient: TSaveClient;
}

export default function AppointmentHeld({
    initialHistories,
    client,
    updateClient,
    updateClientByStatus,
    onSaveClient,
}: AppointmentHeldProps) {
    const uniqueHistories = uniqBy(initialHistories, "id");
    const intakeSessionHistory = client.intake_session_history || [];
    const tabItems = [
        {
            key: "appointment-held-details",
            label: "Appointment Details",
            children: (
                <>
                    {client.held_bookings && client.held_bookings.length > 0 ? (
                        <div className={styles.appointmentHeldDetailsContainer}>
                            {client.held_bookings.map((booking) => (
                                <AppointmentHeldDetails
                                    key={booking.id}
                                    appointment={booking}
                                    client={client}
                                    updateClient={updateClient}
                                    updateClientByStatus={updateClientByStatus}
                                    onSaveClient={onSaveClient}
                                />
                            ))}
                        </div>
                    ) : (
                        <EmptyListState
                            emptyMessage="No appointment held"
                            stateHelperText="No appointments held yet. Details will be added here once the appointment is held."
                        />
                    )}
                </>
            ),
        },
        {
            key: "appointment-held-history",
            label: "Appointment History",
            count: uniqueHistories?.length || "0",
            children: (
                <AppointmentHistory
                    initialHistories={uniqueHistories}
                    client={client}
                    viewFrom="full-page"
                    showHeader={false}
                />
            ),
        },
        {
            key: "intake-session-history",
            label: "Intake Session History",
            count: intakeSessionHistory?.length || "0",
            children: (
                <IntakeSessionHistory
                    initialHistories={intakeSessionHistory}
                    client={client}
                    viewFrom="full-page"
                    showHeader={false}
                />
            ),
        },
    ];

    return <Tabs items={tabItems} className={styles.appointmentHeldTabs} />;
}
